













































import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";

@Component({
  components: {
    "editable-price": () =>
      import(
        "@/components/app/global/baskets/basket/productView/editablePrice.vue"
      )
  }
})
export default class BasketTotals extends Vue {
  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  @Prop({ required: true })
  public showVat!: IBasketProviderData["showVat"];

  @Prop({ required: true })
  public brandTaxType!: IBasketProviderData["brandTaxType"];

  @Prop({ required: true })
  public basket!: IBasketProviderData["basket"];

  @Prop({ required: true })
  public isProcessing!: IBasketProviderData["isProcessing"];

  @Prop({ default: false })
  public canAdjustTotal!: IBasketProviderData["canAdjustTotal"];

  // Data
  public basketTotal = this.basket.total_amount;

  public async createAutoPromotion(value) {
    if (value === this.basket.total_amount) return;

    try {
      this.$basketMethods.set("isProcessing", true);
      await this.$basketMethods.createAutoPromotion(value);
      await this.$basketMethods.refreshBasketData();
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$basketMethods.set("isProcessing", false);
    }
  }

  @Watch("basket.total_amount")
  public onBasketTotalChange() {
    this.basketTotal = this.basket.total_amount;
  }
}
